import { Request, RequestShort } from "../models/Request";
import { RequestTemplateData } from "./RequestTemplateData";
import { RequestImportTemplate } from "./RequestImportTemplate";

export const getRequestTemplate = (
  requestData: Request,
  rowData?: RequestShort,
) => {
  return RequestImportTemplate(prepareData(requestData, rowData));
};

const prepareData = (requestData: Request, rowData?: RequestShort) => {
  let newReproProducts: { name: string; amount: string; note?: string }[] = [];
  if (rowData) {
    const newReproNames = rowData.reproProducts?.split(";") ?? [];
    const newReproAmounts = rowData.reproAmounts?.split(";") ?? [];
    const newReproNotes = rowData.reproNotes?.split(";") ?? [];
    newReproProducts = newReproNames.map((oneReproProduct, index) => ({
      name: oneReproProduct,
      amount: newReproAmounts[index] ?? "",
      note: newReproNotes[index] ?? "",
    }));
  }
  const templateData: RequestTemplateData = {
    request: requestData,
    reproProducts: newReproProducts,
  };

  return templateData;
};
